import React, { useEffect, useState } from "react";
import styles from "./SuccessStoryTestmonials.module.css";
import Image from "next/image";
import Pagination from "../Pagination/Pagination";
import YoutubeVidioPopup from "@/components/YoutubeVidioPopup/YoutubeVidioPopup";
import { formatDate } from "@/utils/utils";

const SuccessStoryTestmonials = ({ data }: any) => {
  const [activeTab, setActiveTab] = useState("All Stories");
  const [isYoutubePopup, setIsisYoutubePopup] = useState(false);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const testimonials = data?.cards?.map((card: any) => ({
    id: card?.id,
    school:
      data?.tabs?.find(
        (tab: any) =>
          tab?.item?.toLowerCase()?.replace(/\s+/g, "-") === card?.school
      )?.item || "Unknown",
    description: card?.profile_data?.title_description?.description || "",
    image: card?.profile_data?.images[0]?.url || "",
    title: card?.profile_data?.title_description?.title || "",
    videoUrl: card?.hear_my_story_link?.url || "",
    VideoLabel: card?.hear_my_story_link?.label || "Hear my story",
    department: card?.department,
    postedAt: card?.posted_at,
  }));

  const filteredTestimonials =
    activeTab === "All Stories"
      ? testimonials
      : testimonials?.filter(
          (testimonial: any) => testimonial?.school === activeTab
        );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const displayedTestimonials = filteredTestimonials.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const scrollToTop = () => {
    const topElement = document.getElementById("top");
    if (topElement) {
      topElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleYoutubePopupClose = () => {
    setIsisYoutubePopup(false);
  };
  const handleVideoPopupOpen = (link: any) => {
    setIsisYoutubePopup(true);
    setYoutubeLink(link);
  };
  return (
    <div id="top" className="mb-4">
      <div className="container mt-4">
        <h2 className={styles.mainTitle}>{data?.title}</h2>
        <div className={styles.tabsContainer}>
          {data?.tabs?.map((tab: any) => (
            <div
              key={tab?.id}
              className={`${styles.tab} ${
                activeTab === tab?.item ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab(tab?.item);
                setCurrentPage(1);
              }}
            >
              {tab?.item}
            </div>
          ))}
        </div>

        <div className={styles.testimonialsContainer}>
          {displayedTestimonials?.length > 0 ? (
            displayedTestimonials?.map((testimonial: any, index: number) => (
              <div key={index} className={styles.card}>
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <Image
                        src={testimonial?.image}
                        alt={
                          testimonial?.alternativeText || "Testimonial Image"
                        }
                        title={testimonial?.title || "Testimonial Image"}
                        width={70}
                        height={70}
                      />
                      <div className="ps-3">
                        <p className={styles.title}>{testimonial?.title}</p>
                        <p className={styles.dept}>
                          {testimonial?.department}
                          {testimonial?.postedAt && (
                            <span className={styles.date}>
                              . {formatDate(testimonial?.postedAt)}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                    <div>
                      <Image
                        src="/assets/quotes.png"
                        alt="Quote"
                        title="Quote"
                        width={isMobile ? 34 : 60}
                        height={isMobile ? 24 : 40}
                        priority
                        className={styles.quote}
                      />
                    </div>
                  </div>
                  <div className={styles.description}>
                    {testimonial?.description}
                  </div>
                  <div>
                    <button
                      className={styles.storyButton}
                      onClick={() =>
                        handleVideoPopupOpen(testimonial?.videoUrl)
                      }
                    >
                      <span> ▶</span> <p>{testimonial?.VideoLabel}</p>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No testimonials available for {activeTab}.</p>
          )}
        </div>
        <div className="d-flex align-items-start">
          {filteredTestimonials?.length > itemsPerPage && (
            <Pagination
              totalItems={filteredTestimonials?.length}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={(page) => {
                setCurrentPage(page);
              }}
              scrollToTop={scrollToTop}
              greenStyle
            />
          )}
        </div>

        {isYoutubePopup && (
          <YoutubeVidioPopup
            isVisibleVideo={isYoutubePopup}
            youtubeVideoLink={youtubeLink}
            onClose={handleYoutubePopupClose}
          />
        )}
      </div>
    </div>
  );
};

export default SuccessStoryTestmonials;
